module.exports = __webpack_public_path__ + "img/Monte_Kope_73.d1b05200.jpg";